// Load Bootstrap JS
import 'bootstrap';

// Load Fontawesome
import './fontawesome';

// Load Js
import './fe_manager';
import './scrolllistener';
import './resizelistener';
import './imagezoom';
import './interferer';
import './nsgallery';
import './sfeventmgt';
import './table_responsive';
//import '../../../../Public/JavaScript/Dist/sfeventmgt.js';
// import './fe_login';

//Cookie
import './cookielistener';

// Load Styles
import '../scss/main.scss';

$(document).ready(function(){
    $("html,body").animate({
        scrollTop: '+=250px'
    },2000);
});


